<div class="queue-page">
  <div class="queue-toolbar">
    <div class="queue-toolbar__copy">
      <p class="queue-kicker">Scheduled draws</p>
      <h2 class="queue-title">My Webinar Queue</h2>
    </div>

    <mat-form-field
      class="queue-room-field"
      appearance="outline"
      *ngIf="hostRoom && hostRoom.length !== 1">
      <mat-label>Webinar Room</mat-label>
      <mat-select
        placeholder="Please select webinar room"
        (selectionChange)="getWebinarData($event)"
        [formControl]="WebinarRoomControl">
        <mat-option *ngFor="let webinarRoom of hostRoom" [value]="webinarRoom.webinarRoomId">
          {{ webinarRoom.roomName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="queue-room-pill" *ngIf="hostRoom && hostRoom.length === 1">
      <mat-icon>storefront</mat-icon>
      <span>{{ selectedRoomName }}</span>
    </div>
  </div>

  <mat-accordion class="queue-accordion" multi *ngIf="webiarQueues && webiarQueues.length > 0">
    <mat-expansion-panel
      *ngFor="let webiarQueue of webiarQueues; let slotIndex = index"
      class="queue-panel"
      [ngClass]="'queue-panel--' + slotTone(webiarQueue, slotIndex)"
      [expanded]="slotIndex === 0">
      <mat-expansion-panel-header collapsedHeight="68px" expandedHeight="68px">
        <div class="slot-header">
          <span class="slot-icon" aria-hidden="true">
            <mat-icon>{{ slotIcon(webiarQueue, slotIndex) }}</mat-icon>
          </span>
          <div class="slot-copy">
            <span class="slot-kicker">Time slot</span>
            <span class="slot-time">{{ formatTimeSlot(webiarQueue.timeSlot) }}</span>
          </div>
          <div class="slot-meta">
            <span class="slot-count">{{ queueCount(webiarQueue) }}</span>
            <span class="slot-count-label">webinars · {{ postedCount(webiarQueue) }} live</span>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="cards-grid" *ngIf="queueCount(webiarQueue); else emptySlot">
        <article
          class="webinar-tile"
          *ngFor="let row of webiarQueue.webinarQueue"
          [class.webinar-tile--free]="isFreeBee(row)"
          [class.webinar-tile--live]="row.isPosted">
          <div class="tile-media">
            <div class="tile-cover" *ngIf="hasCover(row)" [ngStyle]="coverStyle(row)"></div>
            <div class="auto-mark" *ngIf="!hasCover(row)" aria-hidden="true">
              <span class="auto-mark__grid"></span>
              <span class="auto-mark__orbit auto-mark__orbit--outer"></span>
              <span class="auto-mark__orbit auto-mark__orbit--gold"></span>
              <span class="auto-mark__hex"></span>
              <span class="auto-mark__core">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M8.2 6.4v11.2L19 12 8.2 6.4z"/>
                </svg>
              </span>
              <span class="auto-mark__node auto-mark__node--clock" title="Scheduled slot">
                <svg viewBox="0 0 24 24" focusable="false">
                  <circle cx="12" cy="12" r="8.2" fill="none" stroke="currentColor" stroke-width="1.8"/>
                  <path d="M12 8.2v4.1l2.8 1.7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
              </span>
              <span class="auto-mark__node auto-mark__node--loop" title="Automatic hosting">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M7 8.2A6 6 0 0 1 18.4 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                  <path d="M17 15.8A6 6 0 0 1 5.6 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                  <path d="M16.2 6.8 18.6 10l-3.4.7M7.8 17.2 5.4 14l3.4-.7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <span class="freebie-chip" *ngIf="isFreeBee(row)">Freebie</span>
            <span class="tile-status" [class.tile-status--live]="row.isPosted" [class.tile-status--wait]="!row.isPosted">
              {{ row.isPosted ? 'In queue' : 'Not posted' }}
            </span>
            <div class="tile-actions" *ngIf="row.totalSeats === row.availableSeats || isOwnerPortal">
              <button
                mat-icon-button
                matTooltip="Update webinar details"
                (click)="editWebinar(row); $event.stopPropagation()"
                *ngIf="!isOwnerPortal"
                type="button">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                matTooltip="Delete webinar details"
                (click)="onDeleteWebinar(row); $event.stopPropagation()"
                type="button">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>

          <div class="tile-body">
            <h3 class="tile-name" [title]="row.webinarName">{{ row.webinarName }}</h3>
            <p class="tile-room">{{ row.currentRoomName }}</p>

            <div class="tile-stats">
              <div class="tile-stat">
                <span>Items</span>
                <strong>{{ row.itemsInTimeSlot }}</strong>
              </div>
              <div class="tile-stat tile-stat--accent">
                <span>Video</span>
                <strong>{{ formatVideoLength(row.videoLength) }}</strong>
              </div>
              <ng-container *ngIf="!isOwnerPortal">
                <div class="tile-stat" [class.tile-stat--alert]="!row.itemsSuggested">
                  <span>Suggested</span>
                  <strong>{{ row.itemsSuggested }}</strong>
                </div>
                <div class="tile-stat" [class.tile-stat--live]="row.isPosted">
                  <span>Status</span>
                  <strong>{{ row.isPosted ? 'Live' : 'Waiting' }}</strong>
                </div>
              </ng-container>
              <ng-container *ngIf="isOwnerPortal">
                <div class="tile-stat">
                  <span>Total seats</span>
                  <strong>{{ row.totalSeats }}</strong>
                </div>
                <div class="tile-stat tile-stat--alert" [class.tile-stat--live]="row.availableSeats > 0">
                  <span>Open now</span>
                  <strong>{{ row.availableSeats }}</strong>
                </div>
              </ng-container>
            </div>

            <p class="tile-desc" *ngIf="row.description" [title]="row.description">
              {{ roomDescription(row.description) }}
            </p>
          </div>
        </article>
      </div>

      <ng-template #emptySlot>
        <p class="slot-empty">No webinars in this time slot yet.</p>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="queue-empty" *ngIf="webiarQueues && webiarQueues.length === 0">
    <mat-icon>hourglass_empty</mat-icon>
    <h3>No webinars in queue</h3>
    <p>Create a webinar and it will land in the matching time slot here.</p>
  </div>
</div>
